import { render } from "./recent-patients.vue?vue&type=template&id=2b934332"
import script from "./recent-patients.vue?vue&type=script&lang=js"
export * from "./recent-patients.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__